<template>
  <div class="o-card">
    <loading v-if="isLoading"></loading>
    <choose-battery-type
      v-else-if="!form.type"
      @set:batteryType="SET_BATTERY_TYPE"
    ></choose-battery-type>
    <not-auth v-else-if="!hasAuthorize()" />
    <div v-else>
      <battery-features
        @created="CREATED_BATTERY"
        :form="form"
      ></battery-features>
    </div>
  </div>
</template>

<script>
import ChooseBatteryType from "@/components/Batteries/BatteryForm/ChooseBatteryType.vue";
import BatteryFeatures from "@/components/Batteries/BatteryForm/BatteryFeatures.vue";
export default {
  components: {
    ChooseBatteryType,
    BatteryFeatures,
  },
  data() {
    return {
      isLoading: true,
      form: {
        id: null,
        type: null,
      },
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      handler() {
        this.getFormFromQuery();
      },
    },
  },
  methods: {
    hasAuthorize() {
      const list = this.$store.getters["getAuthorizeList"];
      const activeUser = this.$store.getters["getActiveUser"];

      if (activeUser.userInfo.role === "Admin") return true;
      if (this.form.type === "Evaporator") {
        return !list.some(
          (item) => item.authorityInfo.action === "CalculateEvaporatorBattery"
        );
      } else if (this.form.type === "Condenser") {
        return !list.some(
          (item) => item.authorityInfo.action === "CalculateCondenserBattery"
        );
      }
      return false;
    },
    CREATED_BATTERY(battery) {
      this.form = battery;
    },
    SET_BATTERY_TYPE(type) {
      this.form.type = type;
    },
    getFormFromQuery() {
      this.isLoading = true;
      const query = this.$route.query;
      if (query.type) {
        this.SET_BATTERY_TYPE(query.type);
      } else {
        this.form.type = null;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getFormFromQuery();
  },
};
</script>

<style></style>
